/**
 * src/components/ui/GlassButton.tsx
 * Specular action button with luxury variants and loading indicator
 */

import React from 'react';
import { Loader2 } from 'lucide-react';

interface GlassButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'emerald' | 'crimson' | 'ghost' | 'default';
  isLoading?: boolean;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

export const GlassButton: React.FC<GlassButtonProps> = ({
  variant = 'default',
  isLoading = false,
  icon,
  children,
  className = '',
  disabled,
  ...props
}) => {
  const variantClass = variant !== 'default' ? `glass-button-${variant}` : '';

  return (
    <button
      className={`glass-button ${variantClass} ${className}`.trim()}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <Loader2 size={16} className="animate-spin" style={{ animation: 'spin 1s linear infinite' }} />
      ) : (
        icon
      )}
      <span>{children}</span>
    </button>
  );
};
